/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { rightFaqConfig } from '../../config/right-faq-block.config';
import { loadingConfig } from '../../config/loading.config';
import { signUpUserFormConfig } from '../../config/signUpUserForm.config';
import { rowSignupFormData } from '../../config/roesignup.config';
import header from '../../config/header.config.json';

export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    return {
      fields: signUpUserFormConfig?.fields,
      selectFields: signUpUserFormConfig?.selectFields,
      layout: signUpUserFormConfig?.layout,
      title: signUpUserFormConfig?.title,
      otpScreenTitle: signUpUserFormConfig?.otpScreenTitle,
      logo: signUpUserFormConfig?.logo,
      loading: loadingConfig,
      rightBlockContent: rightFaqConfig,
      roeFields: rowSignupFormData?.fields,
      roeLayout: rowSignupFormData?.layout,
      header: header,
    };
  }
}
